import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router'
import { Link, useParams } from 'react-router-dom'

import RemoveGroupMembershipsFromUsersForm from '../../components/userAndGroupForms/RemoveGroupMembershipsFromUsersForm/RemoveGroupMembershipsFromUsersForm'
import useRoutes from '../../state/useRoutes'

export default React.memo(function RemoveGroupMembershipsFromUsersPage() {
  const { uuids: uuidsStr } = useParams()
  const uuids = useMemo(() => uuidsStr!.split(','), [uuidsStr])

  const { close } = useOutletContext<any>()

  return <RemoveGroupMembershipsFromUsersForm userUuids={uuids} onClose={close} />
})

export function RemoveGroupMembershipsFromUsersPageBreadcrumb() {
  const { uuids } = useParams()
  const { t } = useTranslation()
  const routes = useRoutes()
  return (
    <Link to={routes.removeGroupMembershipsFromUsers.url({ uuids: uuids! })}>
      {t('manage group.remove from groups')}
    </Link>
  )
}
